import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'competence',
  store,
  dynamic: true
})
class CompetenceStoreModule extends VuexModule {
  public percentsByCompetences: { [name: string]: number } = {};

  @Mutation
  public setPercentsByCompetences(value: { [name: string]: number }): void {
    this.percentsByCompetences = value;
  }
}

export default getModule(CompetenceStoreModule);
